import { OrganizationListFilter } from './types';

// Stable references so passing a filter down does not remount the stream on
// every render of the calling component.
export const DISTRIBUTORS_FILTER: OrganizationListFilter = {
  case: 'ShowDistributors',
  value: {},
};

export const DSOS_FILTER: OrganizationListFilter = {
  case: 'ShowDSOs',
  value: {},
};

export const ORGANIZATION_LIST_PAGE_SIZE = 20;
